export default {
  home: "首页",
  companyProfile: "企业资料",
  jobPost: "职位",
  booking: "预约面试",
  manage: "管理预约",
  manageFund: "管理基金",
};